import React, { useEffect, useState } from 'react'
import ReactDOMServer from 'react-dom/server'
import ThemeWrapper from 'core/components/theme-wrapper'
import PropTypes from 'prop-types'
import GoogleMapReact from 'google-map-react'

import store from '../../../store'

const GoogleMapComponent = props => {
  const { markers, center, onClickMarker } = props

  const [mapsApi, setMapsApi] = useState()
  const [mapInstance, setMapInstance] = useState()
  const [markersStore, setMarkersStore] = useState([])

  const onMarkerClick = (marker, content, infoWindow) => {
    infoWindow.close()
    infoWindow.setContent(
      ReactDOMServer.renderToString(<ThemeWrapper store={store}>{content}</ThemeWrapper>)
    )
    infoWindow.open(marker.getMap(), marker)
    onClickMarker(marker.id)
  }

  const renderMarkers = (map, maps) => {
    if (!map || !maps) return

    function fitAllBounds(b) {
      const ne = b.getNorthEast()
      const sw = b.getSouthWest()

      const mapBounds = map.getBounds()

      // Check if map bounds contains both north east and south west points
      if (mapBounds && mapBounds.contains(ne) && mapBounds.contains(sw)) {
        // Everything fits
        return null
      }
      const mapZoom = map.getZoom()

      // Min zoom is 3
      if (mapZoom > 3) {
        map.setZoom(mapZoom - 1)
        // Try again
        fitAllBounds(b)
      }
      return null
    }

    const bounds = new maps.LatLngBounds()
    setMapsApi(maps)
    setMapInstance(map)
    setMarkersStore([])

    const infoWindow = new maps.InfoWindow()

    let markerCount = 0
    let pointOfSaleMarkerNum = 1
    markers.forEach(item => {
      const markerTmp = new maps.Marker({
        position: item.position,
        label: item.user ? null : String(pointOfSaleMarkerNum),
        map,
        id: item.id
      })
      markersStore.push(markerTmp)
      setMarkersStore(markersStore)

      if (item.content) {
        markerTmp.addListener('click', () => {
          onMarkerClick(markerTmp, item.content, infoWindow)
        })
      }

      if (markerCount <= 4 && item.position.lat && item.position.lng) {
        bounds.extend(item.position)
        markerCount += 1
      }

      if (!item.user) {
        pointOfSaleMarkerNum += 1
      }
    })
    bounds.extend(center)
    map.fitBounds(bounds)
    map.setCenter(center)

    fitAllBounds(bounds)
  }

  useEffect(() => {
    if (mapInstance && mapsApi) {
      if (markersStore.length > 0) {
        //hide all the existing markers in markersStore
        markersStore.forEach(item => {
          item.setMap(null)
        })
      }

      renderMarkers(mapInstance, mapsApi)
    }
  }, [markers])

  return (
    <GoogleMapReact
      bootstrapURLKeys={
        process.env.NODE_ENV === 'production'
          ? { key: 'AIzaSyC7QLXp7sVaI6WJsAMnrSx757gQzVdWFKM' }
          : { key: 'AIzaSyB2DZC6vtw3XYtSkwlMzQn-qdS-5SazxcM' }
      }
      options={{
        styles: [
          {
            //only applied if apiKey is supplied to google
            featureType: 'poi',
            stylers: [{ visibility: 'off' }]
          }
        ]
      }}
      defaultZoom={14}
      center={center}
      yesIWantToUseGoogleMapApiInternals
      onGoogleApiLoaded={({ map, maps }) => renderMarkers(map, maps)}
    />
  )
}

GoogleMapComponent.defaultProps = {
  markers: []
}

GoogleMapComponent.propTypes = {
  markers: PropTypes.array,
  center: PropTypes.shape().isRequired,
  onClickMarker: PropTypes.func.isRequired
}

export default GoogleMapComponent
